import { PALETA_CLARA, PALETA_ESCURA, Paleta } from "../../../../styles/theme/paletaCores";

export const CORES_OPERADORAS = [
  "#21277B", "#3949AB", "#F6BB3C", "#4444EE", "#47AED7", "#396A41", "#AEB2EA", "#C1ECFD",
  "#5EE6CB", "#BDF6A2", "#D1D5F0", "#FEBE86", "#546FA0", "#BCC7DC", "#A8FBEB", "#CDABF9",
  "#FBB0AA", "#FEDAD8", "#F7A1C9", "#FDF1D8",
];

// Mesmo tom das escuras clareado ate contraste 3:1 com o fundo do cartao escuro
export const CORES_OPERADORAS_ESCURO = CORES_OPERADORAS.map(
  (cor) => ({ "#21277B": "#6468A3", "#3949AB": "#5966B8", "#4444EE": "#5757F0", "#396A41": "#497650" } as { [cor: string]: string })[cor] || cor
);

interface ValorOperadora {
  name: string;
  y: number;
}

export const coresPorRanking = (operadoras: ValorOperadora[], paleta: Paleta = PALETA_CLARA): ((nome: string) => string) => {
  const cores = paleta === PALETA_ESCURA ? CORES_OPERADORAS_ESCURO : CORES_OPERADORAS;
  const porNome: { [nome: string]: string } = {};
  let posicao = 0;
  [...operadoras]
    .sort((a, b) => b.y - a.y)
    .forEach((o) => {
      if (!(o.name in porNome)) {
        porNome[o.name] = cores[posicao % cores.length];
        posicao += 1;
      }
    });
  return (nome: string) => porNome[nome] || paleta.suave;
};
